module.exports = __webpack_public_path__ + "components/cityspotters-story/static/discover-fe349cb816d360746af5f13f32137c47.svg";